VLW.controllers.Actualites = class extends VLW.controllers.Home {
	constructor(a, b) {
		super(a, b);
		this.pixi.align            = "cc";
		this.pixi.displacementType = VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS;
		this.constructor.setStyleMenuHover("color_gris");
		this.mainElementJS_Or = this.mainElementJS;
		this.plus && document.body.appendChild(this.plus);
	}
	
	onRegisterController(ctrl) {
		TweenMax.to(this.mainElementJS, .5, {opacity: 0, pointerEvents: "none"});
		TweenMax.set("[data-cntr='EavActu']", {pointerEvents: "auto"});
		this.mainElementJS = ctrl.mainElementJS;
		this.entite        = ctrl;
		
	}
	outro(){
		this.entite && this.entite.deactivate();
		this.mainElementJS = this.mainElementJS_Or;
		super.outro();
	}
	
	reload() {
		this.entite && this.entite.deactivate();
		this.entite = null;
		this.mainElementJS = this.mainElementJS_Or;
		TweenMax.to(this.mainElementJS, .5, {opacity: 1, pointerEvents: "auto", dleay: .5});
		TweenMax.set("[data-cntr='EavActu']", {pointerEvents: "none"});
	}
	
	introContent(delay = 0) {
		let tl = new TimelineMax({delay});
		tl.set(this.mainElementJS, {opacity: 1});
		tl.addLabel("start");
		tl.fromTo(this.qsa(".vlwScrollBar"), 1.25, {opacity: 0}, {opacity: .7, ease: Sine.easeInOut}, "start+=2");
		tl.fromTo(this.qsa("._logo"), 1.25, {rotationX: 35, transformOrigin: "0% 0%", opacity: 0}, {rotationX: 0, opacity: 1, ease: Sine.easeInOut}, "start");
		tl.add(this.animFilet(), "start");
		tl.staggerFromTo(this.qsa("._ulActu li"), .75, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, .2, "start+=1");
		return true;
	}
	
	loadPIXIResources() {
		let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
		_loader.add("displacement", "/images/displacement/actualites.jpg");
		_loader.load((loader, resources) => {
			this.pixi.resources = resources;
			loader.destroy()
		});
	}
	
	setSplitText() {
		this.mySplitText  = {lines: {}};
		this.mySplitText2 = null;
	}
};